export const INIT_AUTH = 'INIT_AUTH';

export const SIGN_IN_ERROR = 'SIGN_IN_ERROR';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';

export const SIGN_OUT_SUCCESS = 'SIGN_OUT_SUCCESS';



// WEBPACK FOOTER //
// ./src/auth/action-types.js